/**
 * Helpers de erro de API.
 *
 * Backend V2 retorna no padrão:
 *   { success: false, error: "msg", code: "VALIDATION_ERROR", details: [{field, message}, ...] }
 *
 * Formas legadas suportadas: data.message, err.message.
 */

const FIELD_LABELS = {
  name: 'Nome',
  description: 'Descrição',
  category: 'Categoria',
  image_url: 'Imagem',
  sales_page_url: 'Página de Vendas',
  thank_you_page_url: 'Página de Agradecimento',
  complaint_url: 'Reclame Aqui',
  support_email: 'Email de suporte',
  support_phone: 'Telefone de suporte',
  warranty_days: 'Garantia (dias)',
  commission_value_affiliate: 'Comissão afiliado',
  commission_value_manager: 'Comissão gerente',
  commission_value_coproducer: 'Comissão coprodutor',
};

const labelFor = (field) => FIELD_LABELS[field] || field;

/**
 * Recebe o erro do axios e devolve { fieldErrors, message }.
 * - fieldErrors: { [field]: 'msg humanizada' } — pra hidratar `errors` no form
 * - message: string curta pro toast/banner. Resume os campos quando há details.
 */
export const parseApiError = (err, fallback = 'Erro ao processar requisição') => {
  const data = err?.response?.data || {};
  const fieldErrors = {};

  if (Array.isArray(data.details) && data.details.length) {
    data.details.forEach((d) => {
      if (d && d.field) fieldErrors[d.field] = d.message || 'Valor inválido';
    });
    const fieldsHuman = data.details.map((d) => labelFor(d.field)).join(', ');
    return {
      fieldErrors,
      message: `Confira: ${fieldsHuman}`,
    };
  }

  return {
    fieldErrors,
    message: data.error || data.message || err?.message || fallback,
  };
};

/**
 * Dado um objeto de errors {field: msg}, encontra o primeiro campo no DOM
 * (via data-field="<key>") e dá scroll suave + foco. Use depois de setErrors.
 */
export const scrollToFirstError = (fieldErrors) => {
  if (!fieldErrors) return;
  const firstField = Object.keys(fieldErrors)[0];
  if (!firstField) return;
  setTimeout(() => {
    const el = document.querySelector(`[data-field="${firstField}"]`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (typeof el.focus === 'function') el.focus({ preventScroll: true });
    }
  }, 50);
};
